<th #th class="≈px-4 ≈py-3 ≈sticky ≈top-0 ≈z-20">
    <div class="≈overflow-ellipsis">
        <ng-content>

        </ng-content>
    </div>
</th>
